import { TimeHelper } from '@/helpers/TimeHelper';

const userTableColumns = [
  {
    prop: 'name',
    label: 'Name',
    sortable: true
  },
  {
    prop: 'email',
    label: 'Email',
    sortable: true
  },
  {
    prop: 'phone',
    label: 'Phone',
    sortable: true
  },
//   {
//     prop: 'status',
//     label: 'Status',
//     sortable: true
//   }
];

const tableFilters = [
  {
    label: 'Inactive',
    name: 'inactive',
    search: 'status',
    param: 'pending'
  },
  {
    label: 'Deleted',
    name: 'deleted',
    search: 'status',
    param: 'deleted'
  },
  {
    label: 'Recent activity',
    name: 'activity',
    search: 'lastLogin',
    param: TimeHelper.timestampFromDaysAgo(2)
  }
];

const tableOptions = {
  'default-sort': {
    prop: 'createdOn',
    order: 'descending'
  },
  limit: 10,
  searchParams: {
    default: 'name',
    params: [
      {
        label: 'Name',
        value: 'name'
      },
      {
        label: 'Email',
        value: 'email'
      }
    ]
  }
};

export { userTableColumns, tableFilters, tableOptions };
